import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  I18nPrefixConcatPipe,
  I18nProviderInjectionToken as I18nProviderCoreInjectionToken,
} from '@pct-ng/i18n';

@Component({
  selector: 'cappus-dto-common-status',
  imports: [TranslocoPipe, I18nPrefixConcatPipe],
  templateUrl: './status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  protected readonly i18nPrefix = `${I18nProviderCoreInjectionToken.scope}.COMMON`;
  readonly isActive = input.required<boolean>();
}
